<div class="content-header">
  <h2 class="has-text-primary is-size-2-desktop is-size-3-touch is-size-4-mobile">{{ title }}</h2>
  <div class="has-text-link is-size-4">{{ subtitle }}</div>
</div>
